export interface IEquityIssueUserInfo {
  id: number;
  role?: string;
  nationalId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  mobilePhone?: string;
  streetAddress?: string;
  zipCode?: string;
  city?: string;
  actingOnBehalfOf: ActingOnBehalfOf;
  companyId?: string;
  companyName?: string;
  leiCode?: string;
  basicInformationEditable: boolean;
}

export enum ActingOnBehalfOf {
  Personal = "Personal",
  Company = "Company",
}
